









import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/layout/PageHeader.vue'
import TextReplacer from '@/components/TextReplacer.vue'

@Component({
  components: {
    TextReplacer,
    PageHeader
  }
})
export default class App extends Vue {}
